(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-approval"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const footer = document.querySelector('footer.main-footer');
    const header = document.querySelector('header');
    const footerHeight = footer ? footer.offsetHeight : 0;
    const headerHeight = header ? header.offsetHeight : 0;
    const approvalForm = document.querySelector('.approval-form');
    if (approvalForm) {
      document.documentElement.style.setProperty('--header-measure-height', `${headerHeight}px`);
      document.documentElement.style.setProperty('--footer-measure-height', `${footerHeight}px`);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
